import React from "react";
import { Button } from "react-bootstrap";

export default function PayrollTabs({
  activeTab,
  setActiveTab,
}) {

  return (
    <div className="tabs-wrapper">

      <Button
        className={`tab-btn ${
          activeTab === "addition" ? "active-tab" : ""
        }`}
        onClick={() => setActiveTab("addition")}
      >
        Additions
      </Button>

      <Button
        className={`tab-btn ${
          activeTab === "overtime" ? "active-tab" : ""
        }`}
        onClick={() => setActiveTab("overtime")}
      >
        Overtime
      </Button>

      <Button
        className={`tab-btn ${
          activeTab === "deduction" ? "active-tab" : ""
        }`}
        onClick={() => setActiveTab("deduction")}
      >
        Deductions
      </Button>

    </div>
  );
}